export default {
  jobListingCandidateTasks: [],
  jobListingCandidateTask: undefined,
};
